package pl.decks.personal.pages.ievp.sections.profile

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.components.icons.fa.FaBullseye
import com.varabyte.kobweb.silk.components.icons.fa.FaGears
import com.varabyte.kobweb.silk.components.icons.fa.FaMagnifyingGlassChart
import com.varabyte.kobweb.silk.components.icons.fa.FaNetworkWired
import com.varabyte.kobweb.silk.components.icons.fa.FaSeedling
import com.varabyte.kobweb.silk.components.icons.fa.FaTerminal
import pl.decks.personal.pages.ievp.sections.skills.SkillCategory
import pl.decks.personal.theme.SitePalette

internal enum class ProfileDimension(
    val title: String,
    val faGlyph: String,
    val color: (SitePalette) -> Color,
    val categories: List<SkillCategory>,
) {
    CULTURE(
        "Culture & Teamship", "\uf4d8", { it.profile.culture }, listOf(
            SkillCategory.TEAM_CRAFT,
            SkillCategory.COLLABORATION,
            SkillCategory.CHANGE_MANAGEMENT,
            SkillCategory.STRATEGIC_COMMUNICATION,
        )
    ),
    PRODUCT(
        "Product & Business", "\uf140", { it.profile.product }, listOf(
            SkillCategory.DESIGN_UX,
            SkillCategory.CUSTOMER_DISCOVERY,
            SkillCategory.PRODUCT_DEVELOPMENT,
            SkillCategory.GO_TO_MARKET,
        )
    ),
    DATA_ENGINEER(
        "Data Engineering", "\uf6ff", { it.profile.platforms }, listOf(
            SkillCategory.DATA_ARCHITECTURES,
            SkillCategory.STORAGE_PROCESSING,
            SkillCategory.PIPELINES_ORCHESTRATION,
            SkillCategory.FOUNDATIONS_GOVERNANCE,
        )
    ),
    DATA_SCIENTIST(
        "Data Science & Research", "\ue522", { it.profile.analytics }, listOf(
            SkillCategory.KNOWLEDGE_FOUNDATION,
            SkillCategory.RESEARCH_EXPERIMENTATION,
            SkillCategory.MODEL_BUILDING,
            SkillCategory.ANALYTICS_VISUALS,
        )
    ),
    SYSTEMS(
        "Systems & Architectures", "\uf085", { it.profile.systems }, listOf(
            SkillCategory.SECURITY_COMPLIANCE,
            SkillCategory.DISTRIBUTED_DESIGNS,
            SkillCategory.CLOUD_INFRASTRUCTURE,
            SkillCategory.SYSTEM_INTEGRATION,
        )
    ),
    PROGRAMMER(
        "Engineering Craft", "\uf120", { it.profile.software }, listOf(
            SkillCategory.LANGUAGES_DEPTH,
            SkillCategory.FULL_STACK,
            SkillCategory.SYSTEM_ADMINISTRATION,
            SkillCategory.PRACTICES,
        )
    ),
    ;


    @Composable
    fun icon(modifier: Modifier = Modifier) = when (this) {
        SYSTEMS -> FaGears(modifier)
        PROGRAMMER -> FaTerminal(modifier)
        DATA_ENGINEER -> FaNetworkWired(modifier)
        DATA_SCIENTIST -> FaMagnifyingGlassChart(modifier)
        PRODUCT -> FaBullseye(modifier)
        CULTURE -> FaSeedling(modifier)
    }
}
